import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconFlowLabel({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="M3 2a1 1 0 0 0 0 2h5v11a1 1 0 1 0 2 0V4h5a1 1 0 1 0 0-2H3z"/>
        </svg>
    );
}

export default IconFlowLabel;
